/* eslint-disable */
import { GetterTree } from "vuex";
import { Member } from "@/models/member";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { MemberState } from "@/types/member";

const getters: GetterTree<MemberState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Member();
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((member) => {
          return member.id == id;
        })
      : new Member();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((member) => Member.toSelectItem(member))
      : [];
  },
};

export default getters;
